export const GENERAL_SCRIPT = `<script>window.inMarketOpts = {pixId:'%PIXEL_ID%'};</script>\n` +
    `<script src="https://scripts.inmarkethub.com/conversion-tracking/v1.js" type="application/javascript" /> \n`;

export const LANDING_PAGE_SCRIPT = `<script>window.inMarketOpts = {pixId:'%PIXEL_ID%'};</script>\n` +
    `<script src="https://scripts.inmarkethub.com/conversion-tracking/v1.js" type="application/javascript">\n` +
    `<script type="application/javascript">\n` +
    `    inMarket.trackEvent('landingPage');\n` +
    `</script>`;

export const HOME_PAGE_SCRIPT = `<script>window.inMarketOpts = {pixId:'%PIXEL_ID%'};</script>\n` +
    `<script src="https://scripts.inmarkethub.com/conversion-tracking/v1.js" type="application/javascript">\n` +
    `<script type="application/javascript">\n` +
    `    inMarket.trackEvent('homePage');\n` +
    `</script>`;

export const OTHER_SCRIPT = `<script>window.inMarketOpts = {pixId:'%PIXEL_ID%'};</script>\n` +
    `<script src="https://scripts.inmarkethub.com/conversion-tracking/v1.js" type="application/javascript">\n` +
    `<script type="application/javascript">\n` +
    `    inMarket.trackEvent('other');\n` +
    `</script>`;

export const TRACK_CONVERSION_SCRIPT = `<script>window.inMarketOpts = {pixId:'%PIXEL_ID%'};</script>\n` +
    `<script src="https://scripts.inmarkethub.com/conversion-tracking/v1.js" type="application/javascript">\n` +
    `<script type="application/javascript">\n` +
    `    inMarket.trackConversion(‘conversion_name’);\n` +
    `</script>`;
